import { Component } from '@angular/core';
import { ConnectionPointDto } from '@app/api/nts';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { CardComponent } from '@shared/components/card/card.component';
import { ValueDetailsComponent } from '@shared/components/value-details/value-details.component';
import {
  connectionpointLocationDetailsMasterData
} from '@shared/interfaces/nts/connectionpointdata/connectionpoint-location-details.masterdata';
import {
  connectionpointDetailsMasterdata
} from '@shared/interfaces/nts/connectionpointdata/connectionpoint-details.masterdata';
import {
  connectionpointKeyDetailsMasterData
} from '@shared/interfaces/nts/connectionpointdata/connectionpoint-key-details.masterdata';
import { ModalService } from '@app/core/services/modal.service';
import { HeaderService } from '@app/core/services/header.service';
import { TranslatePipe } from '@ngx-translate/core';
import { Columns } from '@shared/interfaces/table/column-config';
import { StateManagerService } from '@shared/state/state-manager.service';
import {
  ConnectionpointEditComponent
} from '@shared/modals/connectionpoint/connectionpoint-edit/connectionpoint-edit.component';
import { formatAddress } from '@app/core/utils/format-address';
import {
  connectionpointOverviewActionMenu
} from '@views/connectionpoint/connectionpoint-overview/connectionpoint-overview.action-menu';
import { hasRole } from '@app/core/guards/has-role.guard';
import { AuthRoles } from '@app/api/dmc';

@Component({
  selector: 'app-connectionpoint-search-overview',
  imports: [
    CardComponent,
    ValueDetailsComponent,
    TranslatePipe
  ],
  templateUrl: './connectionpoint-overview.component.html',
  styleUrl: './connectionpoint-overview.component.css'
})
export class ConnectionpointOverviewComponent {
  public id?: string;

  public connectionPoint?: ConnectionPointDto;

  public locationMasterData: Columns<ConnectionPointDto>[] = connectionpointLocationDetailsMasterData;
  public connectionpointDetailsMasterData: Columns<ConnectionPointDto>[] = connectionpointDetailsMasterdata;
  public keyMasterData: Columns<ConnectionPointDto>[] = connectionpointKeyDetailsMasterData;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly modalService: ModalService,
    private readonly headerMenuService: HeaderService,
    private readonly stateManagerService: StateManagerService,
    private readonly headerService: HeaderService,
  ) {
    const cpWriter = hasRole([AuthRoles.ConnectionPointWriter]);

    this.route.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;

      this.headerMenuService.setActions(
        connectionpointOverviewActionMenu,
        { edit: () => this.openEditModal() },
        { edit: () => !cpWriter }
      );

      this.fetchAndUpdateConnectionPoint();
    });
  }

  public fetchAndUpdateConnectionPoint() {
    this.stateManagerService.getConnectionPoint(this.id!).subscribe((connectionPoint: ConnectionPointDto) => {
        this.connectionPoint = connectionPoint;

        const address = connectionPoint?.address ? formatAddress(connectionPoint.address) : undefined;

        this.headerService.setTitle(address)
      }
    )
  }

  public openEditModal(): void {
    this.modalService.show({
      component: ConnectionpointEditComponent,
      title: 'action.edit',
      actions: [
        {
          type: 'primary',
          label: 'system.button.edit',
          method: 'submit'
        },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
      params: { id: this.id, connectionPoint: this.connectionPoint }
    }).subscribe(() => {
      this.fetchAndUpdateConnectionPoint();
    })
  }
}
